import React, { useState, useEffect } from 'react'
import { Divider } from 'components/divider'
import { Badge } from 'components/badge'
import { ErrorDialog, SuccessDialog, ConfirmDialog, ProgressDialog } from 'components/custom/ResponseDialog'
import { useTranslation } from 'react-i18next'
import {
    customDateFormat,
    customTimeFromDateTimeFormat,
    generateWeekDatesStartFromYesterday,
    generate30DayCalendar,
    customTimeFormat,
    utcDateTimeToBahrainTime,
} from 'utils/common'
import {
    Dropdown,
    DropdownButton,
    DropdownDivider,
    DropdownItem,
    DropdownLabel,
    DropdownMenu,
} from 'components/dropdown'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/table'
import { EllipsisVerticalIcon } from '@heroicons/react/16/solid'
import { EyeIcon, ArrowLeftIcon, XCircleIcon, CheckCircleIcon } from '@heroicons/react/20/solid'
import { CaptainIcon, BoatIcon, RoutesOperationsIcon } from 'components/icons'
import { GET_CAPTAIN_ROUTE_BOAT_HISTORY_LIST } from 'graphql/operations/queries'
import loadingImage from '../../assets/images/boat-loading.gif'
import { AssignBoatDialog, AssignCaptainDialog, RescheduleDialog } from './assignDialog'
import { useMutation, useLazyQuery } from '@apollo/client'

import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { CANCEL_BOAT_ROUTE_TRIP, ACTIVATE_BOAT_ROUTE_TRIP } from 'graphql/operations/mutations'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function CaptainRouteBoatHistory() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    // Boat data
    const [selectedHistory, setSelectedHistory] = useState(null)
    // Dialog Message
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [showConfirmDialog, setShowConfirmDialog] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [showBoatAssignDialog, setShowBoatAssignDialog] = useState(false)
    const [showCaptainAssignDialog, setShowCaptainAssignDialog] = useState(false)
    const [showRescheduleDialog, setShowRescheduleDialog] = useState(false)
    const [historyList, setHistoryList] = useState(null)
    const [historyCount, setHistoryCount] = useState(0)
    const [activityDate, setActivityDate] = useState(
        localStorage.getItem('selectedActivityDate') || moment().format('YYYY-MM-DD')
    )
    const [dateTabs, setTabs] = useState(() => {
        const tabs = generate30DayCalendar()
        const savedDate = localStorage.getItem('selectedActivityDate')
        if (savedDate) {
            return tabs.map(tab => ({
                ...tab,
                current: tab.value === savedDate,
            }))
        }
        return tabs
    })
    const [confirmDialogTitle, setConfirmDialogTitle] = useState(t('Cancel Trip'))
    const [confirmDialogMessage, setConfirmDialogMessage] = useState(t('Are you sure you want to cancel this trip?'))
    const [confirmDialogAction, setConfirmDialogAction] = useState('cancel') // New state to track the action
    const [selectedRouteType, setSelectedRouteType] = useState('DMC') // DMC for Domestic, INL for International
    
    // Cancel All Trips states
    const [showCancelAllDialog, setShowCancelAllDialog] = useState(false)
    const [cancelAllProgress, setCancelAllProgress] = useState([])
    const [isCancellingAll, setIsCancellingAll] = useState(false)
    
    // Selected trips for bulk cancellation
    const [selectedTrips, setSelectedTrips] = useState(new Set())

    // pagination
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const totalPages = Math.ceil(historyCount / rowsPerPage)

    // Get Boat List
    const [getAssignmentHistoryList, { loading: historyListLoading, error: historyListError }] = useLazyQuery(
        GET_CAPTAIN_ROUTE_BOAT_HISTORY_LIST,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.getCaptainRouteBoatHistory.success && data.getCaptainRouteBoatHistory.code === '200') {
                    setHistoryList(data.getCaptainRouteBoatHistory.history)
                    setHistoryCount(data.getCaptainRouteBoatHistory.total_count)
                }
            },
        }
    )

    // Async version of search for awaiting refetch
    const searchAssignmentHistoryAsync = async () => {
        return await getAssignmentHistoryList({
            variables: {
                captainId: null,
                routeId: null,
                boatId: null,
                historyId: null,
                activityDate: activityDate,
            },
        })
    }

    // Search boats Boat List
    const searchAssignmentHistory = () => {
        getAssignmentHistoryList({
            variables: {
                captainId: null,
                routeId: null,
                boatId: null,
                historyId: null,
                activityDate: activityDate,
            },
        })
    }

    useEffect(() => {
        searchAssignmentHistory()
    }, [page, rowsPerPage, activityDate])

    const handleErrClose = () => {
        setShowErrDialog(false)
        setErrorMessage('')
        //DD
        setShowBoatAssignDialog(false)
        setShowCaptainAssignDialog(false)
    }
    const handleSucClose = () => {
        setShowSucDialog(false)
        setSuccessMessage('')
        //DD
        setShowBoatAssignDialog(false)
        setShowCaptainAssignDialog(false)
    }
    const handleCloseDialog = () => {
        console.log('close dialog')
        setShowBoatAssignDialog(false)
        setShowCaptainAssignDialog(false)
        setShowRescheduleDialog(false)
        setSelectedHistory(null)
    }

    // Trip Cancel
    const [cancelTrip, { loading: updateLoading }] = useMutation(CANCEL_BOAT_ROUTE_TRIP, {
        onCompleted: data => {
            if (data?.cancelBoatRouteTrip.code === '200' && data?.cancelBoatRouteTrip.success === true) {
                setShowSucDialog(true)
                setSuccessMessage(data?.cancelBoatRouteTrip.message)
                searchAssignmentHistory()
                setTimeout(() => {
                    setShowSucDialog(false)
                    setSuccessMessage('')
                }, 1500)
            } else {
                setShowConfirmDialog(false)
                setShowErrDialog(true)
                setErrorMessage(data?.cancelBoatRouteTrip.message)
            }
        },
        onError: error => {
            setShowErrDialog(true)
            setErrorMessage(error.message)
        },
    })
    const cancelBoatTrip = params => {
        setSelectedHistory(params)
        setConfirmDialogTitle(t('Cancel Trip'))
        setConfirmDialogMessage(t('Are you sure you want to cancel this trip?'))
        setConfirmDialogAction('cancel')
        setShowConfirmDialog(true)
    }
    const [activateTrip, { loading: updateLoading1 }] = useMutation(ACTIVATE_BOAT_ROUTE_TRIP, {
        onCompleted: data => {
            if (data?.activateBoatRouteTrip.code === '200' && data?.activateBoatRouteTrip.success === true) {
                setShowSucDialog(true)
                setSuccessMessage(data?.activateBoatRouteTrip.message)
                searchAssignmentHistory()
                setTimeout(() => {
                    setShowSucDialog(false)
                    setSuccessMessage('')
                }, 1500)
            } else {
                setShowConfirmDialog(false)
                setShowErrDialog(true)
                setErrorMessage(data?.activateBoatRouteTrip.message)
            }
        },
        onError: error => {
            setShowErrDialog(true)
            setErrorMessage(error.message)
        },
    })
    const activateBoatTrip = params => {
        setSelectedHistory(params)
        setConfirmDialogTitle(t('Activate Trip'))
        setConfirmDialogMessage(t('Are you sure you want to activate this trip?'))
        setConfirmDialogAction('activate')
        setShowConfirmDialog(true)
    }
    
    const rescheduleBoatTrip = params => {
        setSelectedHistory(params)
        setShowRescheduleDialog(true)
    }

    // Get all scheduled trips for current route type
    const getScheduledTripsForCurrentTab = () => {
        if (!historyList) return []
        return historyList.filter(
            history =>
                history.route?.master_route?.route_type?.code === selectedRouteType &&
                (history.status.code === 'SCH' || history.status.code === 'ACT')
        )
    }
    
    // Handle individual trip selection
    const handleTripSelection = (historyId) => {
        setSelectedTrips(prev => {
            const newSet = new Set(prev)
            if (newSet.has(historyId)) {
                newSet.delete(historyId)
            } else {
                newSet.add(historyId)
            }
            return newSet
        })
    }
    
    // Handle select all trips
    const handleSelectAll = (scheduledTrips) => {
        const allScheduledIds = scheduledTrips.map(trip => trip.history_id)
        const allSelected = allScheduledIds.every(id => selectedTrips.has(id))
        
        if (allSelected) {
            // Deselect all
            setSelectedTrips(prev => {
                const newSet = new Set(prev)
                allScheduledIds.forEach(id => newSet.delete(id))
                return newSet
            })
        } else {
            // Select all
            setSelectedTrips(prev => {
                const newSet = new Set(prev)
                allScheduledIds.forEach(id => newSet.add(id))
                return newSet
            })
        }
    }
    
    // Clear selected trips when route type changes
    useEffect(() => {
        setSelectedTrips(new Set())
    }, [selectedRouteType, activityDate])

    // Handle Cancel Selected Trips
    const handleCancelSelectedTrips = async () => {
        if (selectedTrips.size === 0) {
            setShowErrDialog(true)
            setErrorMessage(t('Please select at least one trip to cancel'))
            return
        }
        
        // First, refresh data to get the latest trips
        try {
            const result = await searchAssignmentHistoryAsync()
            
            // Wait a moment for state to update
            await new Promise(resolve => setTimeout(resolve, 300))
            
            // Get fresh scheduled trips after refetch - only selected ones
            const freshHistoryList = result?.data?.getCaptainRouteBoatHistory?.history || historyList
            const selectedScheduledTrips = freshHistoryList.filter(
                history =>
                    selectedTrips.has(history.history_id) &&
                    history.route?.master_route?.route_type?.code === selectedRouteType &&
                    (history.status.code === 'SCH' || history.status.code === 'ACT')
            )
            
            if (selectedScheduledTrips.length === 0) {
                setShowErrDialog(true)
                setErrorMessage(t('No valid scheduled trips selected to cancel'))
                return
            }
            
            // Initialize progress state with selected trips
            const initialProgress = selectedScheduledTrips.map(trip => ({
                historyId: trip.history_id,
                tripDate: trip.activity_date,
                routeName: trip.route?.route_name?.en || '-',
                tripName: trip.trip?.trip_name?.en || '-',
                startTime: trip.start_time,
                status: 'pending', // pending, processing, success, error
                message: ''
            }))
            
            setCancelAllProgress(initialProgress)
            setShowCancelAllDialog(true)
        } catch (error) {
            setShowErrDialog(true)
            setErrorMessage(t('Failed to load trips. Please try again.'))
        }
    }

    // Cancel trips with concurrent worker pool pattern
    const processCancelAllTrips = async () => {
        setIsCancellingAll(true)

        const concurrency = 5
        let index = 0

        const worker = async () => {
            while (index < cancelAllProgress.length) {
                const currentIndex = index++
                const trip = cancelAllProgress[currentIndex]

                // Mark as processing once
                setCancelAllProgress(prev =>
                    prev.map((t, idx) =>
                        idx === currentIndex ? { ...t, status: 'processing' } : t
                    )
                )

                try {
                    const result = await cancelTrip({
                        variables: {
                            historyId: trip.historyId,
                            tripDate: trip.tripDate
                        }
                    })

                    const isSuccess = result.data?.cancelBoatRouteTrip?.success
                    const message = result.data?.cancelBoatRouteTrip?.message || 'Failed to cancel'

                    // Update only one time
                    setCancelAllProgress(prev =>
                        prev.map((t, idx) =>
                            idx === currentIndex
                                ? {
                                      ...t,
                                      status: isSuccess ? 'success' : 'error',
                                      message
                                  }
                                : t
                        )
                    )
                } catch (error) {
                    setCancelAllProgress(prev =>
                        prev.map((t, idx) =>
                            idx === currentIndex
                                ? { ...t, status: 'error', message: error.message }
                                : t
                        )
                    )
                }
            }
        }

        // Start N concurrent workers
        await Promise.all(Array.from({ length: concurrency }, worker))

        // Wait for data refetch to complete before allowing dialog close
        await searchAssignmentHistoryAsync()
        
        // Add delay to ensure React state updates propagate
        await new Promise(resolve => setTimeout(resolve, 500))
        
        setIsCancellingAll(false)
    }

    const closeCancelAllDialog = () => {
        if (!isCancellingAll) {
            setShowCancelAllDialog(false)
            setCancelAllProgress([])
            // Clear selected trips after dialog closes
            setSelectedTrips(new Set())
        }
    }

    return (
        <>
            <div className="mb-6 flex justify-between items-center">
                <button
                    onClick={() => {
                        navigate('/')
                    }}
                    type="button"
                    className="inline-flex items-center gap-x-1.5 rounded-md text-sm"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-5 rtl:rotate-180" />
                    {t('Home')}
                </button>
                <div></div>
            </div>

            <div className="flex flex-wrap items-end justify-between gap-4">
                <div className="max-sm:w-full sm:flex-1">
                    <div className="flex flex-wrap items-center gap-6 sm:flex-nowrap justify-between">
                        <div className="flex flex-wrap items-center gap-6 sm:flex-nowrap mb-4">
                            <h1 className="text-base font-semibold leading-7 text-gray-900 flex items-center">
                                <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10 bg-[#e9eff1] w-[40px] h-[40px]">
                                    <RoutesOperationsIcon className="w-[20px] h-[20px] fill-[#285f74]" />
                                </div>
                                <div>
                                    <span className="ms-3">{t('Scheduled trips')}</span>
                                    <p className="ms-3 text-sm font-normal leading-6 weight-[200] text-gray-500">
                                        {t(
                                            'Real-time updates on boat routes, including departures, arrivals, and schedule changes for a smooth journey'
                                        )}
                                    </p>
                                </div>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
            <Divider />

            {/* Route Type Tabs */}
            <div className="mb-6">
                <div className="border-b border-gray-200">
                    <div className="flex justify-between items-center">
                        <nav aria-label="Route Type Tabs" className="-mb-px flex space-x-8">
                            <button
                                onClick={() => setSelectedRouteType('DMC')}
                                className={classNames(
                                    selectedRouteType === 'DMC'
                                        ? 'border-primary text-primary'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium'
                                )}
                            >
                                {t('Domestic')}
                            </button>
                            <button
                                onClick={() => setSelectedRouteType('INL')}
                                className={classNames(
                                    selectedRouteType === 'INL'
                                        ? 'border-primary text-primary'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium'
                                )}
                            >
                                {t('International')}
                            </button>
                        </nav>
                        {(() => {
                            const scheduledTrips = getScheduledTripsForCurrentTab()
                            const hasScheduledTrips = scheduledTrips.length > 0
                            const hasSelectedTrips = selectedTrips.size > 0
                            
                            if (!hasScheduledTrips) {
                                return null // Hide button when no scheduled trips
                            }
                            
                            return (
                                <button
                                    onClick={handleCancelSelectedTrips}
                                    disabled={historyListLoading || !hasSelectedTrips}
                                    className="inline-flex items-center gap-x-2 rounded-md bg-red px-3.5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    <XCircleIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                    {hasSelectedTrips 
                                        ? `${t('Cancel Selected')} (${selectedTrips.size})`
                                        : t('Cancel Selected')
                                    }
                                </button>
                            )
                        })()}
                    </div>
                </div>
            </div>

            <div className="hidden sm:block">
                <div className="border-b border-gray-200">
                    <nav aria-label="Tabs" className="-mb-px flex space-x-8 overflow-x-auto scrollbar-hide">
                        {dateTabs.map(tab => (
                            <a
                                key={tab.value}
                                href={'#'}
                                onClick={() => {
                                    console.log('Selected tab----:', tab)
                                    setTabs(
                                        dateTabs.map(t =>
                                            t.label === tab.label ? { ...t, current: true } : { ...t, current: false }
                                        )
                                    )
                                    console.log('Selected tab name:', tab.value)
                                    setActivityDate(tab.value)
                                    localStorage.setItem('selectedActivityDate', tab.value)
                                }}
                                aria-current={tab.current ? 'page' : undefined}
                                className={classNames(
                                    tab.current
                                        ? 'border-primary text-primary'
                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                    'whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium flex-shrink-0'
                                )}
                            >
                                {customDateFormat(tab.label)}
                                <p className="text-center text-[12px]"> {tab.day}</p>
                            </a>
                        ))}
                    </nav>
                </div>
            </div>
            {historyListLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">{t('Loading, please wait')}...</p>
                </div>
            )}
            {historyListError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch operations!')}</div>
                </div>
            )}
            {!historyListLoading && !historyListError && historyList?.length === 0 && (
                <div className="text-center py-24 bg-gray-50 mt-8 rounded-lg">
                    <svg
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        className="mx-auto h-12 w-12 text-gray-400"
                    >
                        <path
                            d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                            strokeWidth={2}
                            vectorEffect="non-scaling-stroke"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <h3 className="mt-2 text-sm font-semibold text-gray-900">{t('No data found!')}</h3>
                    <p className="mt-1 text-sm text-gray-500">{t('Try adjusting your search criteria')}</p>
                    <div className="mt-6"></div>
                </div>
            )}
            {!historyListLoading && !historyListError && historyList?.length > 0 && (() => {
                // Filter historyList based on selected route type
                const filteredHistoryList = historyList.filter(
                    history => history.route?.master_route?.route_type?.code === selectedRouteType
                )
                
                if (filteredHistoryList.length === 0) {
                    return (
                        <div className="text-center py-24 bg-gray-50 mt-8 rounded-lg">
                            <svg
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                                className="mx-auto h-12 w-12 text-gray-400"
                            >
                                <path
                                    d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                                    strokeWidth={2}
                                    vectorEffect="non-scaling-stroke"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <h3 className="mt-2 text-sm font-semibold text-gray-900">{t('No data found!')}</h3>
                            <p className="mt-1 text-sm text-gray-500">
                                {selectedRouteType === 'DMC' 
                                    ? t('No domestic routes found for this date')
                                    : t('No international routes found for this date')
                                }
                            </p>
                        </div>
                    )
                }
                
                const scheduledTripsInList = filteredHistoryList.filter(
                    h => h.status.code === 'SCH' || h.status.code === 'ACT'
                )
                const allScheduledSelected = scheduledTripsInList.length > 0 && 
                    scheduledTripsInList.every(h => selectedTrips.has(h.history_id))
                const someScheduledSelected = scheduledTripsInList.some(h => selectedTrips.has(h.history_id))
                
                return (
                    <>
                        <div className="table-custom flex justify-center items-center bg-white p-0">
                            <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
                                <TableHead>
                                    <TableRow>
                                        <TableHeader className="w-12">
                                            {scheduledTripsInList.length > 0 && (
                                                <input
                                                    type="checkbox"
                                                    checked={allScheduledSelected}
                                                    ref={el => {
                                                        if (el) {
                                                            el.indeterminate = someScheduledSelected && !allScheduledSelected
                                                        }
                                                    }}
                                                    onChange={() => handleSelectAll(scheduledTripsInList)}
                                                    className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer z-10"
                                                    title={t('Select All')}
                                                />
                                            )}
                                        </TableHeader>
                                        <TableHeader>{t('Date')}</TableHeader>
                                        <TableHeader>{t('Route')}</TableHeader>
                                        <TableHeader>{t('Route Type')}</TableHeader>
                                        <TableHeader>{t('Boat')}</TableHeader>
                                        <TableHeader>{t('Trip')}</TableHeader>
                                        <TableHeader>{t('Captain')}</TableHeader>
                                        <TableHeader>{t('Trip Time')}</TableHeader>
                                        <TableHeader>{t('Status')}</TableHeader>
                                        <TableHeader className="flex justify-end">{t('Actions')}</TableHeader>
                                    </TableRow>
                                </TableHead>
                                <TableBody className="font-semibold">
                                    {filteredHistoryList.map((history, index) => {
                                    const isPastDate = moment(history.activity_date).isBefore(moment(), 'day')
                                    const isFutureDate = moment(history.activity_date).isAfter(
                                        moment().add(2, 'days'),
                                        'day'
                                    )
                                    const isScheduledOrActive = history.status.code === 'SCH' || history.status.code === 'ACT'
                                    const isSelected = selectedTrips.has(history.history_id)

                                    return (
                                        <TableRow
                                            className={`${
                                                history.status.code === 'SCH'
                                                    ? 'text-[#c78010]'
                                                    : history.status.code === 'ACT' || history.status.code === 'BDS'
                                                    ? 'text-[#319d5d]'
                                                    : history.status.code === 'CMP'
                                                    ? 'text-[#423f3f]'
                                                    : 'text-[#a09b9b]'
                                            } cursor-pointer hover:bg-gray-50 ${isSelected ? 'bg-blue-50' : ''}`}
                                            key={history.history_id}
                                            onClick={() =>
                                                navigate(`/route-operations-details/${history.history_id}`, {
                                                    state: { activity_date: history.activity_date },
                                                })
                                            }
                                            title={`History #${history.history_id}`}
                                        >
                                            <TableCell 
                                                className="w-12"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {isScheduledOrActive ? (
                                                    <input
                                                        type="checkbox"
                                                        checked={isSelected}
                                                        onChange={() => handleTripSelection(history.history_id)}
                                                        className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
                                                    />
                                                ) : (
                                                    <span className="w-4 h-4 block"></span>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {isPastDate} {customDateFormat(history.activity_date)}
                                            </TableCell>

                                            <TableCell>{history.route?.route_name?.en || '-'}</TableCell>
                                            <TableCell>
                                                <Badge
                                                    color={
                                                        history.route?.master_route?.route_type?.code === 'INL'
                                                            ? 'amber'
                                                            : 'emerald'
                                                    }
                                                    className="capitalize"
                                                >
                                                    {history.route?.master_route?.route_type?.description?.en || '-'}
                                                </Badge>
                                            </TableCell>
                                            <TableCell>{history.boat?.name?.en || '-'}</TableCell>
                                            <TableCell>
                                                {history.trip?.trip_name?.en || '-'}
                                                {history.is_trip_private && (
                                                    <Badge color="rose" className="ms-2">{t('Private')}</Badge>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {history.captain?.user_info?.given_name || '-'}{' '}
                                                {history.captain?.user_info?.family_name}
                                            </TableCell>
                                            <TableCell>
                                                {utcDateTimeToBahrainTime(history.start_time) || '-'} -{' '}
                                                {utcDateTimeToBahrainTime(history.end_time) || '-'}
                                            </TableCell>

                                            <TableCell>
                                                <Badge
                                                    color={
                                                        history.status.code === 'SCH'
                                                            ? 'orange'
                                                            : history.status.code === 'INA'
                                                            ? 'purple'
                                                            : history.status.code === 'ACT' || history.status.code === 'BDS'
                                                            ? 'emerald'
                                                            : 'zinc'
                                                    }
                                                    className="capitalize"
                                                >
                                                    {history.status?.description?.en || '-'}
                                                </Badge>
                                            </TableCell>
                                            <TableCell className="text-right">
                                                <Dropdown>
                                                    <DropdownButton
                                                        plain
                                                        aria-label="More options"
                                                        onClick={e => e.stopPropagation()}
                                                        className="cursor-pointer"
                                                    >
                                                        <EllipsisVerticalIcon />
                                                    </DropdownButton>
                                                    <DropdownMenu anchor="bottom">
                                                        <DropdownItem
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                                navigate(
                                                                    `/route-operations-details/${history.history_id}`,
                                                                    { state: { activity_date: history.activity_date } }
                                                                )
                                                            }}
                                                        >
                                                            <EyeIcon />
                                                            <DropdownLabel>{t('View')}</DropdownLabel>
                                                        </DropdownItem>

                                                        {(history.status.code === 'SCH' ||
                                                            history.status.code === 'ACT') &&
                                                            !isPastDate &&
                                                            !isFutureDate && (
                                                                <>
                                                                    <DropdownDivider />
                                                                    <DropdownItem
                                                                        onClick={e => {
                                                                            e.stopPropagation()
                                                                            const params = {
                                                                                historyId: history.history_id,
                                                                                date: history.activity_date,
                                                                                captainId: history.captain?.id,
                                                                                tripId: history.trip?.trip_id,
                                                                                captainName: `${
                                                                                    history.captain?.user_info
                                                                                        ?.given_name || ''
                                                                                } ${
                                                                                    history.captain?.user_info
                                                                                        ?.family_name || ''
                                                                                }`.trim(),
                                                                                boatName: history.boat?.name?.en,
                                                                                boatId: history.boat?.id,
                                                                                startTime: history.start_time,
                                                                                endTime: history.end_time,
                                                                            }
                                                                            console.log('params', params)
                                                                            setSelectedHistory(params)
                                                                            setShowCaptainAssignDialog(true)
                                                                        }}
                                                                    >
                                                                        <CaptainIcon className="w-[15px] h-[15px] fill-[#285f74] group-hover:fill-white" />

                                                                        <DropdownLabel>
                                                                            {t('Change Captain')}
                                                                        </DropdownLabel>
                                                                    </DropdownItem>
                                                                    <DropdownDivider />
                                                                    <DropdownItem
                                                                        onClick={e => {
                                                                            e.stopPropagation()
                                                                            setShowBoatAssignDialog(true)
                                                                            const params = {
                                                                                historyId: history.history_id,
                                                                                date: history.activity_date,
                                                                                captainId: history.captain?.id,
                                                                                tripId: history.trip?.trip_id,
                                                                                captainName: `${
                                                                                    history.captain?.user_info
                                                                                        ?.given_name || ''
                                                                                } ${
                                                                                    history.captain?.user_info
                                                                                        ?.family_name || ''
                                                                                }`.trim(),
                                                                                boatName: history.boat?.name?.en,
                                                                                boatId: history.boat?.id,
                                                                                startTime: history.start_time,
                                                                                endTime: history.end_time,
                                                                            }
                                                                            setSelectedHistory(params)
                                                                        }}
                                                                    >
                                                                        <BoatIcon className="w-[17px] h-[17px] fill-[#285f74] group-hover:fill-white" />
                                                                        <DropdownLabel>
                                                                            {t('Change Boat')}
                                                                        </DropdownLabel>
                                                                    </DropdownItem>
                                                                    <DropdownDivider />
                                                                    <DropdownItem
                                                                        onClick={e => {
                                                                            e.stopPropagation()
                                                                            const params = {
                                                                                historyId: history.history_id,
                                                                                tripId: history.trip?.trip_id,

                                                                                date: history.activity_date,
                                                                                routeName: history.route?.route_name?.en,
                                                                                tripName: history.trip?.trip_name?.en,
                                                                                captainId: history.captain?.id,
                                                                                captainName: `${
                                                                                    history.captain?.user_info
                                                                                        ?.given_name || ''
                                                                                } ${
                                                                                    history.captain?.user_info
                                                                                        ?.family_name || ''
                                                                                }`.trim(),
                                                                                boatName: history.boat?.name?.en,
                                                                                boatId: history.boat?.id,
                                                                                startTime: history.start_time,
                                                                                endTime: history.end_time,
                                                                            }
                                                                            rescheduleBoatTrip(params)
                                                                        }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-[17px] h-[17px] fill-[#285f74] group-hover:fill-white">
                                                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z" clipRule="evenodd" />
                                                                        </svg>
                                                                        <DropdownLabel>
                                                                            {t('Reschedule Trip')}
                                                                        </DropdownLabel>
                                                                    </DropdownItem>
                                                                </>
                                                            )}
                                                        {(history.status.code === 'SCH' ||
                                                            history.status.code === 'ACT') && (
                                                            <>
                                                                <DropdownDivider />
                                                                <DropdownItem
                                                                    onClick={e => {
                                                                        e.stopPropagation()
                                                                        const params = {
                                                                            historyId: history.history_id,
                                                                            tripDate: history.activity_date,
                                                                        }
                                                                        cancelBoatTrip(params)
                                                                    }}
                                                                >
                                                                    <XCircleIcon className="w-[15px] h-[15px] fill-[#285f74] group-hover:fill-white" />

                                                                    <DropdownLabel>{t('Cancel Trip')}</DropdownLabel>
                                                                </DropdownItem>
                                                            </>
                                                        )}
                                                        {history.status.code === 'CAN' && (
                                                            <>
                                                                <DropdownDivider />
                                                                <DropdownItem
                                                                    onClick={e => {
                                                                        e.stopPropagation()
                                                                        const params = {
                                                                            historyId: history.history_id,
                                                                            tripDate: history.activity_date,
                                                                        }
                                                                        activateBoatTrip(params)
                                                                    }}
                                                                >
                                                                    <CheckCircleIcon className="w-[15px] h-[15px] fill-[#285f74] group-hover:fill-white" />

                                                                    <DropdownLabel>{t('Activate Trip')}</DropdownLabel>
                                                                </DropdownItem>
                                                            </>
                                                        )}
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </TableCell>
                                        </TableRow>
                                    )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                        <Divider />
                        {/* <Pagination className="py-6">
                            <PaginationPrevious
                                onClick={() => handlePageChange(page > 0 ? page - 1 : 0)}
                                disabled={page === 0}
                            />
                            <PaginationList>
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <PaginationPage
                                        key={index}
                                        current={index === page}
                                        onClick={() => handlePageChange(index)}
                                    >
                                        {index + 1}
                                    </PaginationPage>
                                ))}
                            </PaginationList>
                            <PaginationNext
                                onClick={() => handlePageChange(page < totalPages - 1 ? page + 1 : totalPages - 1)}
                                disabled={page === totalPages - 1}
                            />
                        </Pagination> */}
                        <Divider />
                    </>
                )
            })()}

            {showErrDialog && (
                <ErrorDialog status={true} title="Error" message={errorMessage} onClose={handleErrClose} />
            )}
            {showSucDialog && (
                <SuccessDialog status={true} title="Success" message={successMessage} onClose={handleSucClose} />
            )}

            {showBoatAssignDialog && (
                <AssignBoatDialog
                    status={true}
                    title="Change Boat"
                    historyParams={selectedHistory}
                    onClose={handleCloseDialog}
                    onSuccess={() => {
                        console.log('BOAT==onSuccess')
                        setShowSucDialog(true)
                        setSuccessMessage('Boat assigned successfully')
                        searchAssignmentHistory()
                        setTimeout(() => {
                            setShowBoatAssignDialog(false)
                            setShowSucDialog(false)
                            setSuccessMessage('')
                        }, 1500)
                    }}
                />
            )}
            {showCaptainAssignDialog && (
                <AssignCaptainDialog
                    status={true}
                    title="Change Captain"
                    historyParams={selectedHistory}
                    onClose={handleCloseDialog}
                    onSuccess={() => {
                        console.log('CAP==onSuccess')
                        setShowSucDialog(true)
                        setSuccessMessage('Captain assigned successfully')
                        searchAssignmentHistory()
                        setTimeout(() => {
                            setShowCaptainAssignDialog(false)
                            setShowSucDialog(false)
                            setSuccessMessage('')
                        }, 1500)
                    }}
                />
            )}
            {showRescheduleDialog && (
                <RescheduleDialog
                    status={true}
                    title={t('Reschedule Trip')}
                    historyParams={selectedHistory}
                    onClose={handleCloseDialog}
                    onSuccess={() => {
                        console.log('RESCHEDULE==onSuccess')
                        setShowSucDialog(true)
                        setSuccessMessage(t('Trip rescheduled successfully'))
                        searchAssignmentHistory()
                        setTimeout(() => {
                            setShowRescheduleDialog(false)
                            setShowSucDialog(false)
                            setSuccessMessage('')
                        }, 1500)
                    }}
                />
            )}
            {showConfirmDialog && (
                <ConfirmDialog
                    status={true}
                    title={confirmDialogTitle}
                    negativeActionText={t('Cancel')}
                    positiveActionText={t('Yes')}
                    message={confirmDialogMessage}
                    onPositive={() => {
                        setShowConfirmDialog(false)
                        console.log('SSSSSS---', {
                            variables: { historyId: selectedHistory.historyId, tripDate: selectedHistory.tripDate },
                        })
                        if (confirmDialogAction === 'cancel') {
                            cancelTrip({
                                variables: { historyId: selectedHistory.historyId, tripDate: selectedHistory.tripDate },
                            })
                        } else {
                            activateTrip({
                                variables: { historyId: selectedHistory.historyId, tripDate: selectedHistory.tripDate },
                            })
                        }
                    }}
                    onNegative={() => {
                        setShowConfirmDialog(false)
                    }}
                />
            )}

            {/* Cancel Selected Trips Dialog - Using Reusable ProgressDialog */}
            <ProgressDialog
                open={showCancelAllDialog}
                onClose={closeCancelAllDialog}
                title={`${t('Cancel Selected Trips')} (${cancelAllProgress.length})`}
                description={
                    isCancellingAll
                        ? t('Cancelling trips, please wait...')
                        : t('The following selected trips will be cancelled. Click OK to proceed.')
                }
                items={cancelAllProgress.map(trip => ({
                    id: trip.historyId,
                    status: trip.status,
                    message: trip.message,
                    title: trip.routeName,
                    subtitle: trip.tripName,
                    tripDate: trip.tripDate,
                    startTime: trip.startTime,
                }))}
                onConfirm={processCancelAllTrips}
                isProcessing={isCancellingAll}
                confirmText={t('OK, Cancel Selected')}
                cancelText={t('Cancel')}
                closeText={t('Close')}
                icon={XCircleIcon}
                iconBgColor="bg-red"
                iconColor="text-red"
                formatItemTitle={(item) => `${item.title} - ${item.subtitle}`}
                formatItemSubtitle={(item) => `${customDateFormat(item.tripDate)} - ${utcDateTimeToBahrainTime(item.startTime)}`}
            />
        </>
    )
}
